import { createSelector } from 'reselect';
import preparedReducer from './reducer';
import { channelMessagesInitial, searchInitial } from './states';
import {
  requestChannels,
  requestChannelInfo,
  showAllChannels,
  refreshChannels,
  requestMessages,
  sendMessage,
  markAsRead,
  editMessage,
  deleteMessage,
  searchMessages,
  clearSearch,
  newMessageReceived,
  messageReadReceived,
  messageEditedReceived,
  messageDeletedReceived,
} from './actions';
import { ChannelsScope } from './types';

export const reducer = preparedReducer;

export const SLICE_NAME = 'chat';

export const selectors = (state) => state[SLICE_NAME];

export const selectChannels = (state) => state[SLICE_NAME]?.channels || [];

export const selectChannelsLoading = (state) => state[SLICE_NAME]?.loading || false;

export const selectChannelsScope = (state) => state[SLICE_NAME]?.channelsScope || ChannelsScope.UNREAD;

export const selectTotalUnreadCount = createSelector(
  [selectChannels],
  (channels) => channels.reduce((sum, channel) => sum + (channel.unreadCount || 0), 0)
);

export const selectChannelsWithUnread = createSelector(
  [selectChannels],
  (channels) => channels
    .filter((channel) => channel.unreadCount > 0)
    .sort((a, b) => (b.lastMessage?.messageID || 0) - (a.lastMessage?.messageID || 0))
);

export const selectChannelMessages = (channelID) => (state) =>
  state[SLICE_NAME]?.messages?.[channelID] || channelMessagesInitial;

export const selectSearch = (state) => state[SLICE_NAME]?.search || searchInitial;

export const selectChannelSending = (channelID) => (state) => !!state[SLICE_NAME]?.sending?.[channelID];

export const actions = {
  requestChannels,
  requestChannelInfo,
  showAllChannels,
  refreshChannels,
  requestMessages,
  sendMessage,
  markAsRead,
  editMessage,
  deleteMessage,
  searchMessages,
  clearSearch,
  newMessageReceived,
  messageReadReceived,
  messageEditedReceived,
  messageDeletedReceived,
};
